// extracted by mini-css-extract-plugin
module.exports = {"container":"unavailable_container__3N3Pm","text":"unavailable_text__to3aL"};